module.exports = __webpack_public_path__ + "static/media/cq_ultimo_mese b.03161f71.svg";